import Announcements from "@dashboard/features/Dashboard/Announcements/Announcements";
import AttentionTasks from "@dashboard/features/Dashboard/AttentionTasks";
import YourRisks from "@dashboard/features/Dashboard/YourRisks";
import YourOpportunities from "@dashboard/features/Dashboard/YourOpportunities";
import OverdueIssues from "@dashboard/features/Dashboard/OverdueIssues";
import YourIssues from "@dashboard/features/Dashboard/YourIssues";
import YourImprovements from "@dashboard/features/Dashboard/YourImprovements";
import Lists from "@dashboard/features/Dashboard/Lists/Lists";
import YearlyCycle from "@dashboard/features/Dashboard/YearlyCycle/YearlyCycle";
import ShortcutsWidget from "@dashboard/features/Dashboard/Shortcuts/ShortcutsWidget";
import {
    faListCheck,
    faBuildingMagnifyingGlass,
    faArrowsSpin,
    faBell,
    faBullhorn,
    faTriangleExclamation,
    faClockRotateLeft,
    faBolt,
    faArrowUpRightDots,
    faChartLine,
    faLink,
    faLightbulbOn,
} from "@fortawesome/pro-solid-svg-icons";
import type { WidgetConfig } from "../../../utils/dashboard.types";
import { IssuesCategoryWidget } from "@dashboard/features/Dashboard/IssuesWidget/IssuesCategoryWidget";
import { IssuesStatusWidget } from "@dashboard/features/Dashboard/IssuesWidget/IssuesStatusWidget";
import { MostVisitedPagesWidget } from "@dashboard/features/Dashboard/MostVisitedPagesWidget";

export const AVAILABLE_WIDGETS: WidgetConfig[] = [
    {
        id: "ATTENTION_TASKS",
        name: "common.attentionTasks",
        component: AttentionTasks,
        icon: faBell,
        iconColor: "text-chameleon-pink",
    },
    {
        id: "YOUR_RISKS",
        name: "common.yourRisks",
        component: YourRisks,
        icon: faTriangleExclamation,
        iconColor: "text-chameleon-pink",
    },
    {
        id: "YOUR_OPPORTUNITIES",
        name: "common.yourOpportunities",
        component: YourOpportunities,
        icon: faLightbulbOn,
        iconColor: "text-chameleon-pink",
    },
    {
        id: "OVERDUE_ISSUES",
        name: "common.overdueIssues",
        component: OverdueIssues,
        icon: faClockRotateLeft,
        iconColor: "text-chameleon-yellow",
    },
    {
        id: "YOUR_ISSUES",
        name: "common.yourIssues",
        component: YourIssues,
        icon: faBolt,
        iconColor: "text-chameleon-yellow",
    },
    {
        id: "YOUR_IMPROVEMENTS",
        name: "common.yourImprovements",
        component: YourImprovements,
        icon: faArrowUpRightDots,
        iconColor: "text-compendia-foreground",
    },
    {
        id: "LISTS",
        name: "common.checklists",
        component: Lists,
        icon: faListCheck,
        iconColor: "text-green-500",
    },
    {
        id: "ISSUES_CATEGORY",
        name: "common.issuesByCategory",
        component: IssuesCategoryWidget,
        icon: faBuildingMagnifyingGlass,
        iconColor: "text-green-500",
    },
    {
        id: "ISSUES_STATUS",
        name: "common.issuesByStatus",
        component: IssuesStatusWidget,
        icon: faBuildingMagnifyingGlass,
        iconColor: "text-green-500",
    },
    {
        id: "YEARLY_CYCLE",
        name: "common.yearlyCycle",
        component: YearlyCycle,
        icon: faArrowsSpin,
        iconColor: "text-green-500",
    },
    {
        id: "MOST_VISITED_PAGES",
        name: "common.mostVisitedPages",
        component: MostVisitedPagesWidget,
        icon: faChartLine,
        iconColor: "text-green-500",
    },
    {
        id: "ANNOUNCEMENTS",
        name: "common.announcements",
        component: Announcements,
        icon: faBullhorn,
        iconColor: "text-compendia-foreground",
    },
    {
        id: "SHORTCUTS",
        name: "dashboard.shortcuts.title",
        component: ShortcutsWidget,
        icon: faLink,
        iconColor: "text-chameleon-green",
    },
];

export function normalizeWidgetId(widgetId: string): string {
    return widgetId.toUpperCase().replaceAll("-", "_");
}

export { DEFAULT_ACTIVE_WIDGETS, STORAGE_KEYS } from "./dashboardConfig";
